import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d8c5595"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-order-list" }
const _hoisted_2 = { class: "status-list" }
const _hoisted_3 = { class: "list-span" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "商品名称"),
  /*#__PURE__*/_createElementVNode("li", null, "单价"),
  /*#__PURE__*/_createElementVNode("li", null, "订单金额"),
  /*#__PURE__*/_createElementVNode("li", null, "订单状态"),
  /*#__PURE__*/_createElementVNode("li", null, "操作")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "list" }
const _hoisted_7 = { class: "yellow" }
const _hoisted_8 = {
  key: 0,
  class: "page-contents"
}
const _hoisted_9 = { class: "page-tips" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_order_no = _resolveComponent("search-order-no")!
  const _component_Search = _resolveComponent("Search")!
  const _component_OrderListItem = _resolveComponent("OrderListItem")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_page_show = _resolveComponent("page-show")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeOrderStatus(0))),
          class: _normalizeClass({ active: _ctx.orderStatus == 0 })
        }, "所有订单", 2),
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeOrderStatus(1))),
          class: _normalizeClass({ active: _ctx.orderStatus == 1 })
        }, "待付款", 2),
        _createElementVNode("span", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeOrderStatus(2))),
          class: _normalizeClass({ active: _ctx.orderStatus == 2 })
        }, "已付款", 2),
        _createElementVNode("span", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeOrderStatus(4))),
          class: _normalizeClass({ active: _ctx.orderStatus == 4 })
        }, "待收货", 2),
        _createElementVNode("span", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeOrderStatus(3))),
          class: _normalizeClass({ active: _ctx.orderStatus == 3 })
        }, "已取消", 2)
      ]),
      (_ctx.orderStatus == 0)
        ? (_openBlock(), _createBlock(_component_search_order_no, {
            key: 0,
            onSetWhere: _ctx.setWhere,
            onShowMoreWhere: _ctx.showMoreWhere
          }, null, 8, ["onSetWhere", "onShowMoreWhere"]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode(_component_Search, { onSetWhere: _ctx.setWhere }, null, 8, ["onSetWhere"]), [
      [_vShow, _ctx.orderStatus == 0 && _ctx.isShowMoreWhere]
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["list-title", { 'list-title-active': !_ctx.isShowMoreWhere||_ctx.orderStatus != 0 }])
    }, _hoisted_5, 2),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
      (_ctx.orderList.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.orderList, (order, index) => {
            return (_openBlock(), _createBlock(_component_OrderListItem, {
              order: order,
              index: parseInt(index)
            }, null, 8, ["order", "index"]))
          }), 256))
        : (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              "image-size": "324",
              image: "/static/free/icon/notSearchGoods.png",
              description: "暂时没有订单哦~！",
              class: "empty"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.gohome())),
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("去逛逛")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.goodstotal > 0&&_ctx.isShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, " 共" + _toDisplayString(_ctx.goodstotal) + "条，每页显示" + _toDisplayString(_ctx.pageSize) + "条，第" + _toDisplayString(_ctx.pageIndex) + "/" + _toDisplayString(Math.ceil(_ctx.goodstotal / _ctx.pageSize)) + "页 ", 1),
          _createVNode(_component_page_show, {
            pageSize: _ctx.pageSize,
            total: _ctx.goodstotal,
            onHandleCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["pageSize", "total", "onHandleCurrentChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}